import React, { useEffect } from "react";
import { motion, useIsPresent } from "framer-motion";
import { HiX } from "react-icons/hi";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { FaGithub, FaLinkedin } from "react-icons/fa";

import "./SideMenu.scss";

export const SideMenu = ({ setMenuOpen }) => {
  const isPresent = useIsPresent();

  useEffect(() => {
    isPresent && (document.body.style.overflow = "hidden");
    !isPresent && (document.body.style.overflow = "unset");
  }, [isPresent]);

  const dragHandler = (e, info) => {
    info.offset.x > 50 && setMenuOpen(false);
  };
  return (
    <div className="backdrop" onClick={() => setMenuOpen(false)}>
      <motion.div
        initial={{ x: 330 }}
        animate={{ x: 0 }}
        exit={{ x: 330 }}
        transition={{ ease: "easeOut" }}
        drag="x"
        dragConstraints={{ left: 0, right: 300 }}
        dragSnapToOrigin={true}
        dragElastic={0.01}
        onDragEnd={dragHandler}
        className="app__sidemenu"
      >
        <HiX className="svg" onClick={() => setMenuOpen(false)} />
        <ul>
          {["home", "about", "work", "skills", "contact"].map((item) => (
            <li key={item}>
              <a href={`#${item}`} onClick={() => setMenuOpen(false)}>
                {item}
              </a>
            </li>
          ))}
          <li key={"blog"}>
            <a
              href="https://ahmedf.hashnode.dev"
              target="_blank"
              rel="noreferrer"
            >
              Blog
            </a>
          </li>
        </ul>

        <div className="app__social-menu">
          <a
            href="https://twitter.com/ahmedjamshed79"
            target="_blank"
            rel="noreferrer"
          >
            <BsTwitter />
          </a>
          <a
            href="https://github.com/ahmedjamshed79"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.instagram.com/ahmedjamshed79/"
            target="_blank"
            rel="noreferrer"
          >
            <BsInstagram />
          </a>
          <a
            href="https://www.linkedin.com/in/ahmedfaraz-79-aj/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin />
          </a>
        </div>
      </motion.div>
    </div>
  );
};
